var exports = {
  "kL": "x4ddf2309--5149c4--container",
  "hl": "x4ddf2309--5149c4--address",
  "Nr": "x4ddf2309--5149c4--card",
  "H2": "x4ddf2309--5149c4--card-content",
  "Q4": "x4ddf2309--5149c4--card-link",
  "ad": "x4ddf2309--5149c4--card-info",
  "pq": "x4ddf2309--5149c4--info",
  "q9": "x4ddf2309--5149c4--price",
  "Q3": "x4ddf2309--5149c4--highway",
  "DB": "x4ddf2309--5149c4--gallery_container",
  "JD": "x4ddf2309--5149c4--objects",
  "O5": "x4ddf2309--5149c4--offers",
  "M3": "x4ddf2309--5149c4--contacts",
  "Mw": "x4ddf2309--5149c4--contacts-builder",
  "WD": "x4ddf2309--5149c4--labels",
};

module.exports = exports;
